export const locale = {
    lang: 'en',
    data: {
        'DEFAULT_DIALOG': {
            'ACCEPT_BTN_TEXT': 'Confirm',
            'CANCEL_BTN_TEXT': 'Cancel'
        }
    }
};
